import React, { Component } from 'react';

class IconStatusWarn extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
                viewBox="0 0 16 16"
            >
                <path
                    fill="#FF4C06"
                    d="M8 0c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm1.13 9.38l.293-5.406a1 1 0 00-.999-1.054h-.848a1 1 0 00-.999 1.054L6.87 9.38h2.26zm-.09 3.36c.24-.23.37-.55.37-.96 0-.42-.12-.74-.36-.97-.24-.23-.59-.35-1.06-.35-.47 0-.82.12-1.07.35-.25.23-.37.55-.37.97 0 .41.13.73.38.96.26.23.61.34 1.06.34.45 0 .8-.11 1.05-.34z"
                ></path>
            </svg>
        );
    }
}

export default IconStatusWarn;